/* @ngInject */
function cacheInterceptor($q, CacheService) {
  const service = {
    request,
    response,
    responseError,
  };

  return service;

  function request(config) {
    if (config.method === 'GET') {
      CacheService.removeAllExpired();
      const cache = CacheService.get(config);
      if (cache) {
        const clone = cache.clone();
        return $q.reject(clone);
      }
    }
    return config;
  }

  function response(result) {
    if (CacheService.isCacheable(result.config)) {
      CacheService.add(result);
    }
    return result;
  }

  function responseError(rejection) {
    if (rejection.isCached) {
      return rejection;
    }
    return $q.reject(rejection);
  }
}

export default cacheInterceptor;



// WEBPACK FOOTER //
// ./src/app/core/cache/cache.interceptor.factory.js